import { useSyncExternalStore } from 'react';

// Small phones plus landscape phones. Tablet portrait widths (600px+) retain
// the full program; pointer/height prevents landscape phones bypassing the limit.
export const PHONE_EXPERIENCE_QUERY = '(max-width: 599px), (pointer: coarse) and (max-height: 499px) and (max-width: 999px)';
const snapshot = () => typeof window !== 'undefined' && !!window.matchMedia?.(PHONE_EXPERIENCE_QUERY).matches;
function subscribe(callback) {
  const media = window.matchMedia?.(PHONE_EXPERIENCE_QUERY);
  if (!media) return () => {};
  if (media.addEventListener) {
    media.addEventListener('change', callback);
    return () => media.removeEventListener('change', callback);
  }
  media.addListener?.(callback);
  return () => media.removeListener?.(callback);
}
export const usePhoneExperience = () => useSyncExternalStore(subscribe, snapshot, () => false);

export function largerScreenOnly(pathname = '') {
  const path = pathname.split(/[?#]/)[0];
  // Assigned document readers are part of employee self-service on phones.
  if (/^\/documents\/workflow\/doc_[A-Za-z0-9]+$/.test(path)) return false;
  // Today owns End of Day and Team keeps its scheduling request destinations.
  if (/^\/(operations\/eod|operations\/journey-planning|operations\/calendar)(\/|$)/.test(path)) return false;
  return /^\/(workspaces?|hiring|hr|documents|payroll|budget|calendar)(\/|$)/.test(path)
    || /^\/operations(\/|$)/.test(path)
    || /^\/scheduling\/(eg|mt|zenoti)(\/|$)/.test(path)
    || path === '/scheduling';
}

export function phoneNavigation(items, phone) {
  return phone ? items.filter(item => !['workspace', 'hiring'].includes(item.id) && (!item.to || !largerScreenOnly(item.to))) : items;
}
